/**
 * Image loading module
 * Handles showing background elements only after images load
 */

export const images = {
    init() {
        this.handleImageLoading()
    },

    handleImageLoading() {
        // Find all image containers
        const imageContainers = document.querySelectorAll('.image-container')

        imageContainers.forEach(container => {
            const img = container.querySelector('img')

            if (!img) return

            // Set up timeout fallback in case onload doesn't fire
            const timeoutId = setTimeout(() => {
                if (!container.classList.contains('image-loaded')) {
                    container.classList.add('image-loaded')
                    console.log('Image load fallback triggered')
                }
            }, 3000) // 3 second fallback

            // Handle image load
            const handleImageLoad = () => {
                clearTimeout(timeoutId)
                container.classList.add('image-loaded')
            }

            // Check if image is already loaded (cached)
            if (img.complete && img.naturalHeight !== 0) {
                handleImageLoad()
            } else {
                // Set up load event listener
                img.addEventListener('load', handleImageLoad, { once: true })

                // Error fallback
                img.addEventListener('error', () => {
                    clearTimeout(timeoutId)
                    container.classList.add('image-loaded') // Show gradient even if image fails
                }, { once: true })
            }
        })
    }
}